import React from 'react';
import { IconButton, Stack, Typography, Box } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useDispatch, useSelector } from 'react-redux';
import { setSelected } from '@/features/table/tasksTableSlice';
import { BulkReassignButton } from '@/components/buttons/BulkActions/BulkReassignButton';
import { MAX_TABLE_SELECTION } from '@/components/table/data';

export const TasksBulkActionsToolbar = () => {
	const dispatch = useDispatch();
	const { selected } = useSelector((state) => state.taskTable);

	if (selected.length === 0) {
		return <></>;
	}

	const hasReachedMax = selected.length >= MAX_TABLE_SELECTION;

	return (
		<Stack direction='row' spacing={2} alignItems='center' sx={{ px: 1, py: 0.5 }}>
			<Box>
				<IconButton size='small' onClick={() => dispatch(setSelected([]))}>
					<ClearIcon />
				</IconButton>
				<Typography variant='task_updated' component='span'>
					{hasReachedMax
						? `Maximum of ${MAX_TABLE_SELECTION} tasks`
						: `${selected.length} task${selected.length > 1 ? 's' : ''} selected`}
				</Typography>
			</Box>

			<BulkReassignButton objectType='task' />
		</Stack>
	);
};

